import 'core-js/stable'; // polyfill for ie11 of object.assign etc.
import $ from 'jquery';
import 'promise-polyfill/src/polyfill';
import '../thirdPartyForks/typeahead.jquery';
import ko from '@tko/build.knockout';
import 'components-bootstrap';
import 'knockstrap';
import '../thirdPartyForks/knockout-projections';
// import 'knockout.validation';
import './bindings/tko-validation';
import './bindings/tko-knockstrap';

import Vue from 'vue';
import VueDomPurifyHtml from 'vue-dompurify-html';

import RouterConfiguration from './router-configuration';
import ComponentRegistration from './component-registration';
import DataProvider from './data-framework/data-provider';
import DataVizUtils from '../services/dataviz.service'

window.jQuery = $;
window.$ = $;
window.ko = ko;

Vue.use(VueDomPurifyHtml);

const acceptedOrigins = [
  'https://my.qa.wxpcollaboration.hp.com',
  'https://localhost.qa.wxpcollaboration.hp.com',
  'https://dev.qa.wxpcollaboration.hp.com',
  'https://my02.qa.wxpcollaboration.hp.com',
  'https://my03.qa.wxpcollaboration.hp.com',
  'https://my04.qa.wxpcollaboration.hp.com',
  'https://my05.qa.wxpcollaboration.hp.com',
  'https://stage.wxpcollaboration.hp.com',
  'https://my.wxpcollaboration.hp.com',
  'https://my.eu.wxpcollaboration.hp.com',
  'https://ustestms.workforceexperience.hp.com/',
  'https://usstagingms.workforceexperience.hp.com/',
  'https://eustagingms.workforceexperience.hp.com/',
  'https://workforceexperience.hp.com/',
  'https://eu.workforceexperience.hp.com/',
];

$(document).ready(function() {
  let dataProvider = DataProvider.getInstance();
  ComponentRegistration.registerAll();
  var router = RouterConfiguration.getRouter(dataProvider);

  // Listen for messages from parent window
  window.addEventListener('message', function(event) {
    // Verify origin for security
    if (!acceptedOrigins.includes(event.origin)) {
      return;
    }
    
    // console.log('Received message:', event.data);
    
    // Handle different message types
    if (event.data.type === 'navigate' && event.data.hash) {
      // Navigate to the specified route
      window.location.hash = event.data.hash;
    }
  });

  var currentPage = ko
      .pureComputed(function () {
          var currentRoute = ko.unwrap(router.currentRoute);
          return currentRoute.page;
      });

  // minimize incompatibilities when upgrading from ko 3.3 to 3.5
  // see https://github.com/knockout/knockout/releases/tag/v3.5.0-beta
  ko.options.createChildContextWithAs = true;
  ko.options.foreachHidesDestroyed = true;

  // Enable bootstrap tooltips site-wide
  $('body').tooltip({
    selector: "[data-toggle='tooltip']"
  });
  // disabled bootstrap modals site-wide on hash change
  $(window).on('hashchange', function() {
    $('.modal').modal('hide');
    $('.modal-backdrop').remove();
  });

  // Start the knockout application
  ko.options.templateSizeLimit = 50000; // 38136, 5101, 10011
  ko.options.allowScriptTagsInTemplates = true; // legacy monitors
  ko.options.useOnlyNativeEvents = false; // tokenfield binding isn't working without this
  ko.options.jQuery = $; // tokenfield binding isn't working without this
  ko.applyBindings({
    debug: true,
      currentPage: currentPage,
      dataProvider: dataProvider,
      route: router.currentRoute
  }, document.body); // this now returns a promise .then(() => {});

  // generate dataViz styles dynamically
  const sheet = new CSSStyleSheet();
  document.adoptedStyleSheets = [...document.adoptedStyleSheets, sheet];
  DataVizUtils.init(sheet);
  
  const isSystemDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const params = new URLSearchParams(window.location.search);
  const themeParam = params.get('theme');
  const themeInLocalStorage = window.localStorage.getItem('wex_last_theme');
  if (themeInLocalStorage) {
    setTheme(themeInLocalStorage, 'found theme in localStorage');
  } else if (themeParam && themeParam !== 'system') {
    setTheme(themeParam, 'found theme param in url');
  } else if (window.localStorage.getItem('theme')) {
    setTheme(window.localStorage.getItem('theme'), 'localStorage had theme');
  } else if (isSystemDarkMode || themeParam) {
    setTheme('dark', 'did not find localStorage but found system preference for dark mode');
  } else if (!window.document.documentElement.classList.contains('light')) {
    setTheme('light', 'no localStorage or system preference, defaulted to light');
  }
  if (themeInLocalStorage) {
    window.addEventListener('storage', (event) => {
      if (event.key === 'wex_last_theme' && event.newValue) {
        setTheme(event.newValue, 'detected theme change in another tab');
      }
    });
  }
  function setTheme(theme, source) {
    document.documentElement.classList.remove('light');
    document.documentElement.classList.remove('dark');
    document.documentElement.classList.add(theme);
  }
});
